export default "__VITE_ASSET__C4cPKv34__"